import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=f033807e&scoped=true"
import script from "./Assessment.vue?vue&type=script&lang=js"
export * from "./Assessment.vue?vue&type=script&lang=js"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=f033807e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f033807e",
  null
  
)

export default component.exports